export default class Enum {
  toString = value => {
    return _.invert(this)[value] || value
  }
}
